import React from "react";

function EmergencyContacts() {
    const emergencyContacts = [
        "Dr. K V RamaRao",
        "Dr. K Sruthi",
        "P Nagamani",
        "J Sesha Naidu",
        "P Praveen",
        "Bhavani Meher",
        "Rajasree G",
        "Triveni N",
    ];

    // "Dr. K V RamaRao - 9492209129",
    // "Dr. K Sruthi- 9100190291",
    // "P Nagamani - 9440926698",
    // "J Sesha Naidu - 9440663357",
    // "P Praveen - 8374188768",
    // "Bhavani Meher - 8125169859",
    // "Rajasree G - 8008475615",
    // "Triveni N - 9700450000",

    return (
        <div className="white-bg" style={{ padding: "20px" }}>
            <div className="caboutus">
            <h3><b style={{ color: "red" }}>Emergency Contact No: 7901070270</b></h3>
                
            </div>
            <br />
            <div className="caboutus">
           
                <b>
                    <p>Health Center Reception No. : 0877-250 3770</p>
                    
                    <p>Ambulance drivers : </p>
                        <ul className='ms-3 c-lineheight2dot5 iarrow' >
                       <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Prasad - 9573940949 </li>
                       <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Jagaiah - 9949762587</li>
                    </ul>
                </b>
            </div>
            <br />
            <div>
                <h3 className="mb-15">Medical Emergency Contacts</h3>
                <ul>
                    {emergencyContacts.map((item, index) => (
                        <li
                            key={index}
                            className="caboutus"
                            style={{ display: "flex", flexDirection: "row" }}
                        >
                            <i
                                className="icon fal fas fa-caret-right pl-5"
                                style={{
                                    display: "block",
                                    alignSelf: "flex-start",
                                    marginTop: "0.31lh",
                                }}
                            />
                            <p className="pl-10">{item}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default EmergencyContacts;
